// Reports one usage event to the area's beacon endpoint (Academy::AnalyticsEventsController).
// Fire-and-forget: keepalive lets it outlive a navigation, and nothing here can
// fail the member's own action — an error is swallowed, not surfaced.
export function sendAnalyticsEvent(name, { subjectType, subjectId, properties = {} } = {}) {
  const url = document.querySelector('meta[name="analytics-events-url"]')?.content
  if (!url) return

  const body = { name, properties }
  if (subjectType && subjectId) {
    body.subject_type = subjectType
    body.subject_id = subjectId
  }

  fetch(url, {
    method: "POST",
    keepalive: true,
    credentials: "same-origin",
    headers: {
      "Content-Type": "application/json",
      "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content || "",
      "Accept": "application/json"
    },
    body: JSON.stringify(body)
  }).catch(() => {})
}
